<template>
  <div>
    <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">

      <div class="row">
        <RangeDatePicker
          id="selected-time-date-picker"
          v-model="filters.dateRange"
          class="col-12 col-md-3 datesFilter"
          :placeholder="$t('optometry.leads.date_range')">

        <div slot="label">
          <label class="form-label" style="margin-top: -3px;">
            {{ $t('statistics.daterange_start') }}
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'created_at', 'selectedDateLabel': filters.date == 'createdAt'}" @click="setDate('created_at')">{{ $t('statistics.daterange_created_at') }}</span>
            <span class="dateSeparatorLabel">/</span>
            <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'updated_at', 'selectedDateLabel': filters.date == 'updatedAt'}" @click="setDate('updated_at')">{{ $t('statistics.daterange_updated_at') }}</span>
            {{ $t('statistics.daterange_end') }}:
          </label>
        </div>
        </RangeDatePicker>

        <!-- Entities Filter -->
        <div class="col-12 col-md-3">
          <label class="form-label">{{$t('users.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entities"
            :options="authorizedEntities"
            track-by="id"
            :custom-label="formatedEntityLabel"
            label="name"
            select-label=''
            selected-label=''
            deselect-label="×"
            placeholder="---"
            :searchable="true"
            :allow-empty="true"
            :multiple="true"
            :close-on-select="false">
            <span slot="noResult">{{$t('optometry.leads.table.no_results')}}</span>
            <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>{{ option.name }}&nbsp;<span v-if="option.entities"> 📂</span></span>
                  <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                </span>
            </template>
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="filters.entities.length" @mousedown.prevent.stop="filters.entities = []"></div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <v-server-table
      id="optometryLeadsTable"
      ref="optometryLeadsTable"
      :name="'optometryLeadsTable'"
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleLeadClicked">

       <span slot="has_visual_loss" slot-scope="props">
        <span :title="$t('optometry.leads.table.has_visual_loss')" v-if="props.row.has_visual_loss">
          <i class="fa fa-check"></i>
        </span>
      </span>

      <span slot="entity" slot-scope="props">
        {{ authorizedEntities ? authorizedEntities.some(entity => entity.id === props.row.entity_id) ? authorizedEntities.find(entity => entity.id === props.row.entity_id).name : "N/A" : "N/A"}}
      </span>

      <span slot="updated_at" class="no-break" slot-scope="props">{{ props.row.updated_at | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="created_at" class="no-break" slot-scope="props">{{ props.row.created_at | localTime('YYYY-MM-DD HH:mm') }}</span>

    </v-server-table>
  </div>

</template>

<script>
import RangeDatePicker from '@/components/common/RangeDatePicker'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    RangeDatePicker,
    Multiselect,
  },
  mixins: [
    IsFromEvolluMixin,
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      filters: {
        querySearch: '',
        entities: [],
        date: 'created_at',
        dateRange: {
          start: null,
          end: null
        }
      },
      numberVisibleLeads: 0,
      showTags: false,
      queryUrl: `${this.$store.state.optometry_server}/admin/leads`,
      columns: ['created_at', 'updated_at', 'full_name', 'address_city', 'has_visual_loss', 'entity'],
      tableOptions: {
        orderBy: {
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at', 'updated_at', 'name', 'entity'],
        sortable: ['created_at', 'updated_at', 'name', 'city'],
        customFilters: ['entities', 'start', 'end', 'date'],
        headings: {
          created_at: this.$t('leads.table.created_at'),
          updated_at: this.$t('leads.table.updated_at'),
          full_name: this.$t('leads.table.name'),
          address_city: this.$t('leads.table.address_city'),
          has_visual_loss: this.$t('optometry.leads.table.vl'),
          entity: this.$t('leads.table.entity'),
        },
        columnsClasses: {
          created_at: 'created_at',
          updated_at: 'updated_at',
          name: 'name',
          city: 'city',
          has_visual_loss: 'has_visual_loss',
          entity: 'entity'
        },
      }

    }
  },
  created: function () {
    this.checkActiveFilters()
  },
  methods: {
    handleLeadClicked: function ({ row }) {
      let selectedLead = row
      selectedLead.entity = this.authorizedEntities ? this.authorizedEntities.some(entity => entity.id === row.entity_id) ? this.authorizedEntities.find(entity => entity.id === row.entity_id) : null : null
      this.$emit('leadClicked', selectedLead)
    },
    reload: function () {
      this.$refs.optometryLeadsTable.refresh()
    },
    onLoading: function () {
      this.$emit('loading')
    },
    onLoaded: function (state) {
      this.$emit('loaded', state)
    },
    setDate: function (date) {
      this.filters.date = date
    },
    checkActiveFilters: function () {
      return new Promise((resolve) => {
        this.$emit('filters-updated', this.activeFilters)
        if (this.activeFilters > 0) {
          this.$emit('update:showFilters', true)
        }
        resolve()
      })
    },
  },
  computed: {
    activeFilters: function () {
      let count = 0
      if (this.filters.entities.length > 0) count++
      if (this.filters.dateRange.start || this.filters.dateRange.end) count++
      return count
    },
    authorizedEntities: function () {
      let optometryService = this.$store.state.services.find(service => service.url === this.$store.state.optometry_server) || null
      if (optometryService) {
        if (optometryService.user_permissions.some(p => p.entity_id === null)) {
          return optometryService.entities
        } else {
          return optometryService.entities.filter(entity => optometryService.user_permissions.filter(p => p.entity_id === entity.id))
        }
      }
      return null
    },
  },
  watch: {
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    customQueries: {
      handler: function (value) {
        if (value.entities && value.entities !== '') {
          this.filters.entities = this.authorizedEntities.filter(ent => value.entities.split(',').some(elem => parseInt(elem) === ent.id))
        }
        if (value.date && value.date !== '') {
          this.filters.date = value.date
        }
        if (value.start && value.start !== '') {
          this.filters.dateRange.start = value.start
        }
        if (value.end && value.end !== '') {
          this.filters.dateRange.end = value.end
        }
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs.optometryLeadsTable.setFilter(value)
    },
    'filters.dateRange': function (value) {
      this.$refs.optometryLeadsTable.customQueries.start = value.start || ''
      this.emitTableFilter('vue-tables.optometryLeadsTable.filter::end', value.end || '')
    },
    'filters.date': function (date) {
      if (date === '') {
        this.$refs.optometryLeadsTable.customQueries.date = date
      } else {
        this.emitTableFilter('vue-tables.optometryLeadsTable.filter::date', date)
      }
    },
    'filters.entities': function (options) {
      const optionsIds = options.map(option => option.id).join(',')
      this.emitTableFilter('vue-tables.optometryLeadsTable.filter::entities', optionsIds)
    },
    activeFilters: function (nrFilters) {
      this.$emit('filters-updated', nrFilters)
    }
  }
}
</script>

<style lang="scss">

.unselectedDateLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  text-decoration: line-through !important;
}

.dateSeparatorLabel {
  font-size: 0.6rem !important;
  color: #ada7a1 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

.selectedDateLabel {
  font-size: 0.6rem !important;
  color: #29c4a9 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
}

</style>
